WiseMetering.Views.CircuitSchedule = WiseMetering.Views.BaseSchedule.extend({
    colors: WiseMetering.Colors.Schedules,
    template: 'templates/ui/schedule/circuit_schedule'
});
